function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .crossSVG {\r\n        fill: currentColor;\r\n        stroke-width: 0px;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  className: "crossSVG",
  points: "13 5.2 10.3 8 7.6 5.2 5.2 7.6 8 10.3 5.2 13 7.6 15.3 10.3 12.6 13 15.3 15.3 13 12.6 10.3 15.3 7.6 13 5.2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "crossSVG",
  d: "M17.6,3C15.6,1,12.9,0,10.3,0S5,1,3,3C-1,7-1,13.5,3,17.6s4.6,3,7.3,3,5.3-1,7.3-3c4-4,4-10.5,0-14.5ZM16.4,16.4c-1.6,1.6-3.8,2.5-6.1,2.5s-4.5-.9-6.1-2.5c-1.6-1.6-2.5-3.8-2.5-6.1s.9-4.5,2.5-6.1c1.6-1.6,3.8-2.5,6.1-2.5s4.5.9,6.1,2.5h0c1.6,1.6,2.5,3.8,2.5,6.1s-.9,4.5-2.5,6.1Z"
});

var SvgX = function SvgX(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "crossSVG",
    "data-name": "Layer 1",
    viewBox: "0 0 20.6 20.6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgX, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/X.fc0d8c2c.svg";
export { ForwardRef as ReactComponent };